import { normalizeAssistantText } from '@/lib/assistantFreeText';

/** El cliente quiere modificar, deshacer o preguntar si puede cambiar el pedido. */
export function matchesOrderCorrectionIntent(text) {
  const n = normalizeAssistantText(text);
  return (
    /\b(puedo\s+cambiar|quiero\s+cambiar|mejor\s+cambio|cambiar\s+algo)\b/.test(n) ||
    /\b(mejor\s+no|no\s+lo\s+quiero|no\s+quiero\s+eso|quitalo|sacalo|borralo|cancela\s+eso)\b/.test(n) ||
    /\b(equivoque|me\s+equivoque|mejor\s+otro|otra\s+cosa)\b/.test(n)
  );
}

/** Pide ver resumen / detalle del pedido actual. */
export function matchesOrderDetailRequest(text) {
  const n = normalizeAssistantText(text);
  return (
    /\b(manda|envia|envía|muestra|mostra|mostrá|ver)\s+(el\s+)?(detalle|resumen|pedido)\b/.test(n) ||
    /\b(cual\s+es\s+mi\s+pedido|que\s+llevo|qué\s+llevo|detalle\s+del\s+pedido)\b/.test(n)
  );
}

/** Quiere cerrar / pagar / mandar el pedido. */
export function matchesCheckoutReadyIntent(text) {
  const n = normalizeAssistantText(text);
  return (
    /\b(listo|eso\s+es\s+todo|cerrar\s+pedido|finalizar|mandar\s+pedido|enviar\s+pedido|ir\s+a\s+pagar|pagar\s+ya)\b/.test(n) ||
    /\b(ya\s+esta|ya\s+está|vamos\s+con\s+eso|dale\s+nomas|dale\s+nomás)\b/.test(n)
  );
}
